import * as React from 'react';
import {Grid, Theme, Tooltip, Typography} from '@material-ui/core';
import {createStyles, withStyles} from '@material-ui/core/styles';

const styles = ({spacing}: Theme) => createStyles({
    logoSvg: {
        display: 'block',
        marginBottom: spacing(2),
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: spacing(4),
        maxWidth: '75%',
        minHeight: spacing(2),
        minWidth: spacing(2),
    },
    text: {
        marginBottom: spacing(2),
        marginTop: spacing(4),
    }
});

const Logo = (props: any) => {
    const {classes} = props;

    return (
        <Grid item xs={12}>
            <Tooltip title='Admin!'>
                <Typography align='center' variant='h2' className={classes.text}>
                    Admin
                </Typography>
            </Tooltip>
        </Grid>
    );
};

export default withStyles(styles)(Logo);
